module.exports = __webpack_public_path__ + "img/flask.a38b0df5.png";